module.exports = __webpack_public_path__ + "img/Blumenwiese-768.33cea39c.jpg";